import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function newToken() {
  return crypto.randomUUID();
}

function toFormData(fields, files = []) {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => fd.append(k, v ?? ""));
  files.forEach((f) => fd.append("photos", f));
  return fd;
}

export async function submitEstimate(fields, files) {
  const res = await axios.post(`${API}/leads/estimate`, toFormData(fields, files), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function submitContact(fields) {
  const res = await axios.post(`${API}/leads/contact`, toFormData(fields), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

// Normalizes backend errors into { form?: string, fieldErrors: {} }
export function parseError(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && !Array.isArray(detail)) {
    const { form, ...fieldErrors } = detail;
    return { form, fieldErrors };
  }
  if (typeof detail === "string") return { form: detail, fieldErrors: {} };
  return { form: "Something went wrong while sending your request. Please try again.", fieldErrors: {} };
}
